import { render, staticRenderFns } from "./PropertyQuicklinks.vue?vue&type=template&id=2a47f302&scoped=true&"
import script from "./PropertyQuicklinks.vue?vue&type=script&lang=js&"
export * from "./PropertyQuicklinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47f302",
  null
  
)

export default component.exports